import Header from 'Components/Header/Header';
import NotificationContent from 'Components/Notifications/NotificationContent';
import React from 'react'

// Client notifications - same shared 14b list as the attorney and admin pages
function NotificationsPage() {
  return (
    <>
      <Header />
      <div className='flex col-span-6 w-full flex-col font-plexsans' style={{ background: '#f7f4ed', minHeight: 'calc(100vh - 64px)' }}>
        <div className='w-full max-w-[960px] mx-auto px-5 py-8 lg:px-10 lg:py-12'>
          <NotificationContent title="Notifications" />
        </div>
      </div>
    </>
  )
}

export default NotificationsPage
